export enum BaseCategory {
  Politics = "politics",
  Elections = "elections",
  World = "world",
  Financials = "financials",
  Economics = "economics",
  Companies = "companies",
  Crypto = "crypto",
  ScienceAndTechnology = "science-and-technology",
  Education = "education",
  Health = "health",
  ClimateAndWeather = "climate-and-weather",
  Transportation = "transportation",
  Entertainment = "entertainment",
  Social = "social",
  Sports = "sports",
  Other = "other",
  Mentions = "mentions",
  Commodities = "commodities",
}
